var _style, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  id: "logo_svg__Layer_1",
  x: 0,
  y: 0,
  viewBox: "0 0 214.6 84.7"
}, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".logo_svg__st1,.logo_svg__st2{fill-rule:evenodd;clip-rule:evenodd;fill:#89bd25}.logo_svg__st2{fill:#89bd26}")), /*#__PURE__*/React.createElement("path", {
  d: "M61.7 9.5h9.5c-.2 10.7 0 21.4.5 32.1 4.1-4.3 8.3-8.6 12.5-12.8 4.2-.3 8.4-.3 12.5 0-8.3 8.1-16.8 16.1-25.3 23.8-.3 5.4-.3 10.7-.3 16.1h-9.5c.1-19.7.1-39.5.1-59.2",
  style: {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#88bc23"
  }
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M37.6 44.1v7H15c-.1-3.6 1.6-5.9 5-6.8 2.8 0 5.4-.4 8-1-1.2-7.3-5.2-9.6-12-7-2 1.9-3.2 4.1-3.8 6.8Q8 64.25 29 61.4c2.4-.4 4.7-.9 7-1.8.5 2.7.7 5.3.5 8-2.9.7-5.7 1.3-8.5 2H18C8.7 68.1 3.2 62.5 1.5 53.2v-8q4.35-19.95 24.6-16.8c7.4 2.5 11.2 7.8 11.5 15.7",
  className: "logo_svg__st1"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M114.4 69.7h-6.5c-9.5-3.7-12.3-10.4-8.3-20.1 2.9-3.6 6.7-5.5 11.3-5.8 2.7-.3 5.4-.3 8 0 .4 2.1-.1 4-1.5 5.8-2.7 1.4-5.5 2.5-8.5 3.3q-3 3.75 0 7.5c4.9 2.2 9.4 1.5 13.3-2.3.3-5.9.3-11.7 0-17.6q-.9-3.9-4.8-4.8-4.5-.45-9 0-3.75 1.05-7.5 1.8c-.2-2.5 0-4.9.5-7.3 8-3.4 16-3.6 24.1-.5 4.1 2.2 6.3 5.7 6.8 10.3.2 7.9.3 15.7.5 23.6.2 1.6.6 3.1 1.3 4.5-2.8.6-5.7.7-8.5.3-.9-1.2-1.7-2.5-2.5-3.8q-3.9 3.6-8.7 5.1",
  className: "logo_svg__st2"
})), /*#__PURE__*/React.createElement("path", {
  d: "M44.2 28.6h10v40.2h-10z",
  style: {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#8abd27"
  }
}), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M81.3 46.6c1.1.5 2 1.4 2.8 2.5 4.3 6.4 8.8 12.8 13.3 19.1-3.8.7-7.7.7-11.5 0-2.7-4-5.2-8.2-7.3-12.5-.6-3.5.3-6.5 2.7-9.1",
  className: "logo_svg__st1"
})), /*#__PURE__*/React.createElement("path", {
  d: "M37.6 44.1c.5 2.4.7 4.9.5 7.5-7.8.2-15.5 0-23.1-.5h22.6z",
  style: {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#94c338"
  }
}), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M143.5 56.7c5.9 1.2 7.6 4.5 5.3 10-5.4 3.7-9 2.3-10.8-4 .5-3.3 2.4-5.3 5.5-6",
  className: "logo_svg__st2"
})));
export default SvgLogo;